import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Move from '@/components/move'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/move',
      name: 'move',
      component: Move
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js